// Copyright © 2021 Move Closer

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const UnauthorizedMiddlewareType = Symbol.for('UnauthorizedMiddleware')
